<template lang="html">
  <div>

    <div class="subnav">
      <div class="columns">
        <div class="column is-offset-one-quarter is-one-quarter has-text-centered">
          <a href="#" v-scroll-to="'#curtis'" class="is-uppercase">MegaCurtis</a>
        </div>
      </div>
    </div>

    <section class="section appEven" id="curtis">
      <div class="container has-text-centered pb-3">
        <h1 class="title is-size-1-desktop is-size-1-tablet is-size-3-mobile">MegaCurtis</h1>
        <h2 class="subtitle">Turn any recording into a synthesizer</h2>
      </div>

      <div class="container">
        <div class="columns">

          <div class="column">
            <div class="">
              <figure class="image is-2by3">
                <img src="~@/assets/img/curtis_iphone.png">
              </figure>
            </div>
          </div>

          <div class="column">
            <div class="content">
              <h1 class="title">Unique Synthesis</h1>
              <p>Use the built-in presets or any recording to create sounds never heard before. Make a synth from opera, from screeching cats, from the latest radio newscast. Create tones and timbres quite apart from the standard FM or subtractive synthesis fare. Any sound will lend its unique properties to MegaCurtis!</p>
            </div>

            <div class="content">
              <h1 class="title">Gravetable™</h1>
              <p>Granular synthesis works by combining many tiny grains of sound from an existing recording. Wavetable synthesis works by sweeping through a series of single-cycle waveforms. MegaCurtis uses our hybrid of granular and wavetable synthesis, Gravetable™, combining the periodicity of wavetable synthesis with the chop and overlap of granular synthesis.</p>
            </div>

            <div class="content">
              <div class="pb-1">
                <a class="button is-link" href="https://vimeo.com/39604000">
                  <span class="icon">
                    <i class="fab fa-vimeo"></i>
                  </span>
                  <span>Watch Video</span>
                </a>
              </div>

              <div>
                <a class="button is-link" href="https://itunes.apple.com/us/app/megacurtis/id504331059?ls=1&mt=8">
                  <span class="icon">
                    <i class="fab fa-app-store"></i>
                  </span>
                  <span>Download for iPhone</span>
                </a>
              </div>

              <figure class="">
                <a href="https://itunes.apple.com/us/app/megacurtis/id504331059?ls=1&mt=8">
                  <img src="~@/assets/img/app-store.svg" width="256">
                </a>
              </figure>
            </div>
          </div>
        </div>

      </div>

      <div class="container">
        <div class="columns">

          <div class="column">
            <div class="content pad-phone">
              <a class="button is-primary" href="#" v-scroll-to="'#top'">
                <span class="icon">
                  <i class="fas fa-arrow-up"></i>
                </span>
                <span>Back to top</span>
              </a>
            </div>
          </div>

        </div>
      </div>

    </section>

  </div>
</template>
<script>
export default {
  name: 'iphone'
}
</script>



// WEBPACK FOOTER //
// src/components/iPhone.vue